import { render } from "./MainNavigation.vue?vue&type=template&id=f3b78258&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=f3b78258&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b78258"]])

export default __exports__